// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"FrameworkLayout--next-sr-only--3UTsOTJ","frameworkLayout":"FrameworkLayout--frameworkLayout--2eH9ZFB"};